import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function Careers() {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <div className="careers-page bg-dark text-light">
      <div
        className="position-relative"
        style={{
          minHeight: "600px",
          overflow: "hidden",
        }}
      >
        <img
          src="/images/careers-2.jpg"
          alt="Careers Background"
          onLoad={handleImageLoad}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 0,
            opacity: imageLoaded ? 1 : 0,
            transition: "opacity 0.9s ease-in-out",
          }}
        />

        <div
          className="position-absolute w-100 h-100"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        ></div>

        <div
          className="position-absolute top-50 start-50 translate-middle text-center"
          style={{
            maxWidth: "800px",
            padding: "20px",
            zIndex: 2,
            opacity: 1,
            transition: "opacity 1.2s ease-in-out 0.3s",
          }}
        >
          <h1
            className="fw-bold display-5"
            style={{
              color: "#fffcf5",
              textShadow: "2px 2px 6px rgba(0, 0, 0, 0.7)",
            }}
          >
            Change the Future with PSRIT
          </h1>
          <p
            className="mt-3"
            style={{
              color: "#fffcf5",
              fontWeight: 600,
              textShadow: "1px 1px 4px rgba(0, 0, 0, 0.5)",
            }}
          >
            Join a company that values expertise, creativity, and innovation.
            Become a part of the PSRIT Team and leave your mark on the future of
            tech!
          </p>
        </div>
      </div>
      <div className="py-5" style={{ backgroundColor: "rgba(0, 0, 0, 0.1)" }}>
        <div className="container">
          <h2 className="text-center fw-bold mb-5" style={{ color: "#fffcf5" }}>
            Our Values
          </h2>

          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div
                className="p-4 h-100 rounded-4 shadow-lg"
                style={{ backgroundColor: "#fffaf0", color: "#000" }}
              >
                <h5 className="fw-bold mb-3" style={{ color: "#4a1717" }}>
                  Why Join Us?
                </h5>
                <ul>
                  <li>Exciting projects with new tools and technologies.</li>
                  <li>Continuous learning and development programs.</li>
                  <li>Culture of teamwork and open communication.</li>
                  <li>
                    Competitive salary and benefits (including health
                    insurance).
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div
                className="p-4 h-100 rounded-4 shadow-lg"
                style={{ backgroundColor: "#fffaf0", color: "#000" }}
              >
                <h5 className="fw-bold mb-3" style={{ color: "#4a1717" }}>
                  What We’re Looking For
                </h5>
                <ul>
                  <li>Problem solvers with creativity and determination.</li>
                  <li>Excitement for solving complex challenges.</li>
                  <li>Team-oriented and collaborative mindset.</li>
                  <li>Innovative and forward-thinking individuals.</li>
                </ul>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div
                className="p-4 h-100 rounded-4 shadow-lg d-flex flex-column justify-content-between"
                style={{ backgroundColor: "#fffaf0", color: "#000" }}
              >
                <div>
                  <h5 className="fw-bold mb-3" style={{ color: "#4a1717" }}>
                    Current Openings
                  </h5>
                  <p>
                    Take a look at our exciting career opportunities. If you
                    don’t see the perfect fit, we’d still love to hear from you!
                  </p>
                </div>
                <p className="mt-4 fw-bold">
                  Contact us at{" "}
                  <a
                    href="mailto:careers@psritservices.com"
                    className="text-decoration-none"
                    style={{ color: "#4a1717" }}
                  >
                    careers@psritservices.com
                  </a>
                </p>
                <div className="mt-2">{/* Future form placeholder */}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Careers;
